<div class="row reverse-tax-table">
  <div class="col-auto">
    <h5 class="text-muted text-uppercase pb-3">
      {{ 'document-view-public.document-reverse-tax-table.title' | translate }}
    </h5>
  </div>
  <!-- <div class="col"><hr class="mt-0"></div> -->
  <div class="w-100"></div>

  <div class="col-auto">
    <hr class="mt-0" />
    <app-document-taxes-table
      [taxes]="taxes"
      [locale]="locale"
      [currency]="currency"
    ></app-document-taxes-table>
  </div>
</div>

<!-- Total -->
<!-- <div class="row">
  <div class="col-8">
    <p>
      <strong>{{ 'Total' | translate }}</strong>:
    </p>
  </div>
  <div class="col text-right">
    <p>
      <strong>
        {{ reverseTaxTotal | pepCurrency : currency: activeOrg.locale: 2 }}
      </strong>
    </p>
  </div>
  <div class="col-sm-12"><hr class="mt-0"></div>
</div> -->
<!-- // Total -->
